(ns arthur.flow.measure.brows
  "Head-local brow rings and outer/inner raise signals, measured against the
  rigid eye corners so blinking cannot masquerade as an eyebrow movement."
  (:require [arthur.domain.geom :as geom]
            [arthur.domain.landmarks :as lm]
            [arthur.flow.measure.anchor :as anchor]))

(defn- midpoint [a b]
  {:x (/ (+ (:x a) (:x b)) 2) :y (/ (+ (:y a) (:y b)) 2)})

(defn- distance [a b]
  (js/Math.hypot (- (:x a) (:x b)) (- (:y a) (:y b))))

(defn- local-track [dense transforms aspect table]
  (mapv (fn [frame tf]
          (geom/apply-sim-all tf (anchor/pick frame table aspect)))
        dense transforms))

(defn measure
  [{:keys [aspect debug?]} {:keys [dense transforms]}]
  (let [track (partial local-track dense transforms aspect)
        a (track lm/BROW-A-RING)
        b (track lm/BROW-B-RING)
        corners-r (track lm/EYE-R-CORNERS)
        corners-l (track lm/EYE-L-CORNERS)
        centre-x (fn [ring] (:x (geom/centroid ring)))
        side-votes (reduce +
                           (map (fn [ar [ro ri] [lo li]]
                                  (if (< (abs (- (centre-x ar) (:x (midpoint ro ri))))
                                         (abs (- (centre-x ar) (:x (midpoint lo li)))))
                                    1 -1))
                                a corners-r corners-l))
        a-right? (pos? side-votes)
        right (if a-right? a b)
        left (if a-right? b a)
        outer-votes (reduce +
                            (mapcat (fn [rings corners]
                                      (map (fn [ring [outer inner]]
                                             (if (< (distance (first ring) outer)
                                                    (distance (first ring) inner))
                                               1 -1))
                                           rings corners))
                                    [right left] [corners-r corners-l]))
        outer-at-zero? (pos? outer-votes)
        end-outer (if outer-at-zero? lm/BROW-END-0 lm/BROW-END-1)
        end-inner (if outer-at-zero? lm/BROW-END-1 lm/BROW-END-0)
        signal (fn [rings corners]
                 (mapv (fn [ring [outer inner]]
                         (let [c (midpoint outer inner)
                               w (max 1e-9 (distance outer inner))
                               at (fn [[i j]] (/ (+ (:y (nth ring i))
                                                    (:y (nth ring j))) 2))]
                           {:x (/ (- (:y c) (at end-outer)) w)
                            :y (/ (- (:y c) (at end-inner)) w)}))
                       rings corners))]
    {:ring-r right :ring-l left
     :raise-r (signal right corners-r)
     :raise-l (signal left corners-l)
     :outer-at-zero? outer-at-zero? :a-right? a-right?
     :debug (when debug? {:side-votes side-votes :outer-votes outer-votes
                          :raise-r (signal right corners-r)
                          :raise-l (signal left corners-l)})}))
